import React, { Component } from 'react';
import { Col, Row, ListGroup, ListGroupItem, Container, FormGroup, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import { IconLocation, IconList, IconBottom, IconFolder, ArrowBack } from '../../assets/icons/svgIcon';
import { data } from '../../constants/Constants';
import { AuthContext } from "../../store/provider/AuthProvider";
import { FiltroBuscarPedidoSugerido, BuscarPedidoSugerido } from '../../store/sagas/pedidoApi';
import { AgregarNuevoProductoPedidoMasivo } from '../../store/sagas/carritoApi';
import { notificacion, getStatePage } from '../../utilitarios/util';
import localStorageCustom from '../../utilitarios/localStorage';
import TooltipLeyenda from '../reusable/TooltipLeyenda';
import c from '../../constants/Colors';
import Spinner from "../reusable/Loader";
import FormFeedback from 'reactstrap/lib/FormFeedback';

export class PedidoSugerido extends Component {
  static displayName = PedidoSugerido.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      collapse1: false,
      loading: true,
      filtroLocal: [],
      page: 1,
      size: data.PageSizePedidoSugeridoMax,
      currentPage: 1,
      dealer: {},
      linea: {},
      selectedLocal: null,
      pedidosSugerido: [],
      pedidosSugeridoAgregar: [],
      pedidosSugeridoEliminados: [],
      TotalRows: 0,
      asociado: {}
    };
  }

  load = () => {
    let dato = localStorageCustom.prototype.getUsuario();
    this.setState({ dealer: dato.dealer, linea: dato.linea, asociado: dato.asociado }, () => {
      this.postFiltroBuscarPedidoSugerido(dato.linea.vkorg, dato.linea.linea, dato.dealer.codcliente, dato.dealer.correoElectronico);
    } );
  }

  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      this.load();
    } else
      window.location.href = "/";
  }

  render() {
    const { collapse1, page, size, currentPage, loading, filtroLocal, selectedLocal, pedidosSugerido, Total } = this.state;
    const navigation = this.props.navigation
    // const auth = React.useContext(AuthContext);
    const auth = this.context;

    let obj = filtroLocal.length == 0 ? null : filtroLocal.find(x => x.id == selectedLocal);

    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Pedido Sugerido</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Pedidos</li>
              <li>Pedidos Sugeridos</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            Pedido Sugerido</h6>
          <div className="card">
            <SvgAssets icon="curve-bottom" fill={'#1B52B2'} className='curve-top mobile' />
            {/* <div className="card-razon-social">
              <div>
                <div className="header-collapse">{(obj) == null ? "[Seleccione...]" : obj.descripcion}</div>
                <UncontrolledCollapse toggler="#toggler">
                  {(filtroLocal.length > 0) ? filtroLocal.map((item, index) => {
                    return (
                      <div key={index + 1} className="body-collapse" onClick={() => this.setSelectedValue(item.id, data.Sistema)}>
                        {item.descripcion}
                      </div>
                    )
                  }) : null
                  }
                </UncontrolledCollapse>
              </div>
              <div className="arrow-collapse" id="toggler" style={{ background: '#2DB997' }}>
                <IconBottom />
              </div>
            </div> */}
            <FormGroup className="icon mb-4 w-100" style={{ maxWidth: 360, margin: 'auto' }}>
              <Input className="verde" type="select" onChange={(itemValue) => this.setSelectedValue(itemValue, data.Sistema)}>
                <option value="">Direcciones</option>
                {(filtroLocal.length > 0) ? filtroLocal.map((item, index) => {
                  return (
                    // <div key={index + 1} className="body-collapse" onClick={() => this.setSelectedValue(item.id, data.Sistema)}>
                    //   {item.descripcion}
                    // </div>
                    <option key={index + 1} value={item.id} >{item.descripcion}</option>
                  )
                }) : null
                }
              </Input>
            </FormGroup>

            <hr className="desktop mb-5" style={{ borderColor: '#E2E2E2' }} />
            {(pedidosSugerido.length == 0) ?
              <p className="error-1">No se han encontrado resultados, por favor intente nuevamente</p> :
              <ListGroup flush className="container_840">
                <ListGroupItem>
                  <Row form>
                    <Col xs={3} md={4} />
                    <Col xs={2} md={2}>
                      <span className='paragraph-3 bold' style={{ color: '#2DB997' }}>Can.</span>
                    </Col>
                    <Col xs={5} md={4}>
                      <span className='paragraph-3 bold' style={{ color: '#7371FF' }}>Precio Uni.</span>
                    </Col>
                    <Col xs={2} md={2}>
                      <span className='paragraph-3 bold' style={{ color: '#316ACD' }}>Total</span>
                    </Col>
                  </Row>
                  <div className="desktop">
                    <TooltipLeyenda
                      color={c.azulClaro}
                      style={{ position: 'absolute', right: 0, top: 10 }}
                    />
                  </div>
                </ListGroupItem>
                {pedidosSugerido.map((item, index) => {
                  return (
                    (item.visible) ?
                      <ListGroupItem key={index}>
                        <Row form >
                          <Col xs={3} md={4}>
                            <span className='paragraph-3 bold desktop_parrafo2' style={{ color: c.azulClaro }}>{item.maktx}</span>
                            <span className='paragraph-3 desktop_parrafo4' style={{ color: c.grisMedio }}>SKU: {item.matnr}</span>
                          </Col>
                          <Col xs={2} md={2}><span className='paragraph-2 bold' style={{ color: c.verdeClaro }}>{item.canti}</span></Col>
                          <Col xs={5} md={4}>
                            <span className='paragraph-3 bold desktop_parrafo2' style={{ color: c.morado }}>{item.precioPVD}</span>
                            <span className='paragraph-3 light' style={{ color: c.morado }}>PVP S/ {item.precioPublico}</span>
                          </Col>
                          <Col xs={2} md={2} className="item-flex">
                            <span className='paragraph-3 bold desktop_parrafo2' style={{ color: '#316ACD' }}>{item.sWaers} {item.total}</span>
                            <button className="btn-icon ml-auto"
                              onClick={() => { this.eliminarProducto(item, index) }} >
                              <SvgAssets icon="icon-trash" fill={'#9AC8FF'} />
                            </button>
                          </Col>
                        </Row>
                      </ListGroupItem>
                      : null
                  )
                })}
              </ListGroup>
            }
            {(pedidosSugerido.length > 0) ?
              <span className='total-price mt-5' style={{}}>TOTAL: {pedidosSugerido[0].sTotalPagar}</span>
              : null}
            {pedidosSugerido.length > 0 ?
              <div className="mobile">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <button className={`m-0 btn-block ${(filtroLocal.length == 0 || pedidosSugerido.filter(x => x.visible).length == 0) ? ' disabled' : ''}`}
                    disabled={filtroLocal.length == 0 || pedidosSugerido.filter(x => x.visible).length == 0}
                    onClick={() => { this.addPedidos(auth.carritoProdctos, auth.setcarritoProdctos, data.Pantalla) }}
                  ><SvgAssets icon="icon-cart" fill="#fff" className="mr-2" />AGREGAR AL CARRITO</button>
                  <TooltipLeyenda
                    color={c.celeste}
                    style={{ marginLeft: 10 }}
                  />
                </div>
              </div>
              : null}
          </div>
          <div className="text-center mt-5 desktop">
            <button className={`btn-block ${(filtroLocal.length == 0 || pedidosSugerido.filter(x => x.visible).length == 0) ? ' disabled' : ''}`}
              disabled={filtroLocal.length == 0 || pedidosSugerido.filter(x => x.visible).length == 0}
              onClick={() => { this.addPedidos(auth.carritoProdctos, auth.setcarritoProdctos, data.Pantalla) }}
            ><SvgAssets icon="icon-cart" fill="#fff" className="mr-2" />AGREGAR AL CARRITO</button>
          </div>
        </Container>
      </div>
    );
  }

  postFiltroBuscarPedidoSugerido(Vkorg, Linea, CodigoDealer, CorreoElectronicoDealer) {

    FiltroBuscarPedidoSugerido(Vkorg, Linea, CodigoDealer, CorreoElectronicoDealer)
      .then(result => {
        if (result.mo.type == "success") {

          this.setState({
            loading: false,
            filtroLocal: result.dto.filtro,
            selectedLocal: (result.dto.filtro.length > 0) ? result.dto.filtro[0].id : null
          });

          // this.setState({ pedidosSugerido: [], TotalRows: 0 })
           this.postBuscarPedidoSugerido(this.state.linea, this.state.dealer, this.state.selectedLocal, this.state.asociado, this.state.page, this.state.size, data.Sistema);

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Pedidos Sugeridos", error.message ?? null);
        });
      });
  }

  ToggleCollapse1 = () => {
    this.setState(prevState => ({ collapse1: !prevState.collapse1 }))
  }

  setSelectedValue(e, sistema) {
    let value = e.currentTarget.value;
    this.setState({ selectedLocal: value });
    this.setFilter(value, sistema)
  }

  setFilter(value, sistema) {
    if (value)
      this.postBuscarPedidoSugerido(this.state.linea, this.state.dealer, value, this.state.asociado, this.state.page, this.state.size, sistema);
    else this.setState({ pedidosSugerido: [], TotalRows: 0 });
  }

  postBuscarPedidoSugerido(linea, dealer, Dest, asociado, PageNumber, PageZise, Sistema) {
    this.setState({ loading: true })

    BuscarPedidoSugerido(linea.vkorg, linea.linea, dealer.codcliente, dealer.codcliente, Dest, asociado.poblacion, asociado.moneda, PageNumber, PageZise, Sistema)
      .then(result => {
        if (result.mo.type == "success") {
          console.log("result.dto===>", result.dto);
          this.setState({
            loading: false,
            pedidosSugerido: result.dto.pedidosSugerido,
            TotalRows: (result.dto.pedidosSugerido.length > 0) ? result.dto.pedidosSugerido[0].totalRows : 0
          });

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Pedidos Sugeridos", error.message ?? null);
        });
      });
  }

  postMostrarSoloVisibles(linea, dealer, Dest, asociado, PageNumber, PageZise, Sistema) {
    this.setState({ loading: true })

    BuscarPedidoSugerido(linea.vkorg, linea.linea, dealer.codcliente, dealer.codcliente, Dest, asociado.poblacion, asociado.moneda, PageNumber, PageZise, Sistema)
      .then(result => {
        if (result.mo.type == "success") {

          let nuevaLista = [];
          result.dto.pedidosSugerido.map((item, index) => {
            item.visible = this.buscarEliminado(item)
            if (this.buscarEliminado(item)) {
              nuevaLista.push(item);
            }
          });

          if (nuevaLista.length > 0) {
            nuevaLista[0].sTotalPagar = this.restarTotal(nuevaLista[0]);
          }

          this.setState({
            loading: false,
            pedidosSugerido: nuevaLista
          });

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Pedidos Sugeridos", error.message ?? null);
        });
      });
  }

  setPage = (index, change, type) => {
    this.setState({ loading: true });

    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({
        page: index,
        currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1),
        loading: false
      });
    }
    else
      this.setState({ page: index, loading: false })

    this.postMostrarSoloVisibles(this.state.linea, this.state.dealer, this.state.selectedLocal, this.state.asociado, index, this.state.size, data.Sistema);

  }

  addPedidos(carritoProdctos, setcarritoProdctos, pantalla) {

    this.setState({ loading: true });

    BuscarPedidoSugerido(this.state.linea.vkorg, this.state.linea.linea, this.state.dealer.codcliente, this.state.dealer.correoElectronico,
      this.state.selectedLocal, this.state.asociado.poblacion, this.state.asociado.moneda, this.state.page, this.state.TotalRows, data.Sistema)
      .then(result => {
        if (result.mo.type == "success") {

          let nuevaLista = [];
          result.dto.pedidosSugerido.map((item, index) => {
            item.visible = this.buscarEliminado(item)
            if (this.buscarEliminado(item)) {
              nuevaLista.push(item);
            }
          });

          if (nuevaLista.length > 0) {
            nuevaLista[0].sTotalPagar = this.restarTotal(nuevaLista[0]);
          }

          this.setState({
            pedidosSugeridoAgregar: nuevaLista
          });

          const correoElectronico = this.state.dealer.correoElectronico
          const codcliente = this.state.dealer.codcliente
          const centro = this.state.linea.centro
          const linea = this.state.linea.linea
          const vkorg = this.state.linea.vkorg
          const almacen = this.state.linea.almacen
          const canal = this.state.linea.canal
          const sector = this.state.linea.sector

          let ListaProductos = [];
          let data = this.state.pedidosSugerido.filter(x => x.visible);
          data.filter(function (item) {
            ListaProductos.push({
              "CorreoElectronicoDealer": correoElectronico,
              "DispositivoDealer": null,
              "Descripcion": item.maktx,
              "CantidadOriginal": item.canti,
              "Moneda": item.waers,
              "Pantalla": pantalla.General.PedidoSugerido,
              "Sustituto": "SI",
              "UnidadMedida": item.meins,
              "PrecioFinal": item.pfin,
              "Codigo": item.matnr,
              "CodigoDealer": codcliente,
              "Centro": centro,
              "Linea": linea,
              "Vkorg": vkorg,
              'Almacen': almacen,
              'Canal': canal,
              'Sector': sector
            });
          });
          AgregarNuevoProductoPedidoMasivo(ListaProductos)
            .then(result => {
              if (result.mo.type == "success") {
                this.setState({ loading: false });
                // setcarritoProdctos(carritoProdctos + ListaProductos.length);
                setcarritoProdctos(result.dto.carritoProdctos);
                notificacion("Aviso", "Se agregaron productos al carrito");
              } else {
                throw new Error(result.mo.listMessage.join(", "));
              }
            }).catch((error) => {
              this.setState({ loading: false }, async () => {
                error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
                await notificacion("Detalle Pedidos", error.message ?? null);
              });
            });

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Pedidos Sugeridos", error.message ?? null);
        });
      });
  }

  buscarEliminado = (item) => {
    let eliminado = true;
    this.state.pedidosSugeridoEliminados.map((pedido) => {
      if (pedido.id == item.id) { eliminado = false; };
    });
    return eliminado;
  }

  restarTotal = (item) => {
    let total = item.totalPagar;
    this.state.pedidosSugeridoEliminados.map((pedido) => {
      total = Number((item.totalPagar - pedido.total).toFixed(2));
    });
    return total;
  }

  eliminarProducto(item, index) {
    this.setState({ loading: true });
    item.visible = false;
    var arr = this.state.pedidosSugeridoEliminados;
    arr.push(item);
    this.setState({
      pedidosSugeridoEliminados: arr
    });

    let stotal = 0;
    this.state.pedidosSugerido.filter(x => x.visible).map((item2) => {
      stotal = stotal + item2.total;
    });


    this.state.pedidosSugerido[0].sTotalPagar = stotal; //this.restarTotal(item)
    this.setState({
      loading: false
    });

  }
}
